module.exports = __webpack_public_path__ + "img/horizontal_6_1_3016.f3752c2c.png";